/* eslint-disable no-restricted-globals */
export const filteredOptionsHelper = (options, inputValue, group, groupKey) => {
  if (!group) {
    return options?.filter((item) => {
      if (!inputValue) {
        return item;
      }
      const prepareSearch = inputValue.replace(/\s/g, '').toLowerCase();
      if (!prepareSearch.split(',').filter(Boolean).every(isNaN)) {
        return prepareSearch
          .split(',')
          .filter(Boolean)
          .filter((e) => !isNaN(e))
          .some((value) => String(item.id).replace(/\s/g, '').toLowerCase().includes(value));
      }
      return (item.title + item.id).replace(/\s/g, '').toLowerCase().includes(prepareSearch);
    });
  }
  return options
    ?.reduce((acc, item) => {
      const filteredServices = item?.[groupKey]
        .filter((item) => {
          if (!inputValue) {
            return item;
          }
          const prepareSearch = inputValue.replace(/\s/g, '').toLowerCase();

          if (!prepareSearch.split(',').filter(Boolean).every(isNaN)) {
            return prepareSearch
              .split(',')
              .filter(Boolean)
              .filter((e) => !isNaN(e))
              .some((value) => String(item.id).replace(/\s/g, '').toLowerCase().includes(value));
          }

          return (item.title + item.id).replace(/\s/g, '').toLowerCase().includes(prepareSearch);
        });

      return [
        ...acc,
        filteredServices.length > 0 && {
          id: item.id,
          title: item.title,
          isGroupHeader: true,
        },
        ...filteredServices,
      ];
    }, [])
    ?.filter(Boolean);
};

export const heightRow = (name, screenWidth, menuWidth) => {
  const stringLength = screenWidth < 535 ? 20 : menuWidth / 10 || 1;
  const rows = Math.ceil(name.length / stringLength);
  const basicHeight = 32;
  const step = rows === 1 ? 0 : 8;

  return rows * step + basicHeight;
};
